module.exports = __webpack_public_path__ + "img/gb862-1-1987.prt.afe37efd.jpg";